import React from 'react'
import ReactDOM from 'react-dom'
import { GTM_CODE, SUB_DIRECTORY } from 'constants/general'
import { ClearCacheProvider } from 'react-clear-cache'
import './index.sass'
import App from './App'
import * as serviceWorkerRegistration from './serviceWorkerRegistration'
import reportWebVitals from './reportWebVitals'
import TagManager from 'react-gtm-module'

const tagManagerArgs = {
  gtmId: GTM_CODE,
  dataLayerName: 'PageDataLayer'
}

TagManager.initialize(tagManagerArgs)

ReactDOM.render(
  <ClearCacheProvider filename={`${SUB_DIRECTORY}build.json`} duration={3600000}>
    <React.StrictMode>
      <App />
    </React.StrictMode>
  </ClearCacheProvider>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
